import React, { useState, useEffect, useRef, useCallback } from "react";
import { UTILS, INS } from "../../config/API";
import { useNavigate } from 'react-router-dom';
import RadioField from "../RadioField";
import CheckboxField from "../CheckboxField";
import SignatureCanvas from "react-signature-canvas";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from 'jspdf';
import ConfirmationModal from "../ConfirmationModal";
import autoTable from "jspdf-autotable";

const FuelInventory = ({ initialData = {}, onDataChange }) => {
    const navigate = useNavigate();
    const [formSections, setFormSections] = useState({
        taxrevenue: { fields: [], title: "Tax Revenue Information", signature: null, signatureText: "", fileUpload: null, fileUploadText: "", fileTypes: "" }
    });
    const [isLoading, setIsLoading] = useState(true);
    const inputRef = useRef(null);
    const timeoutRef = useRef(null);
    const isCalculatingRef = useRef(false);

    const [inputValue, setInputValue] = useState("");
    const [emailError, setEmailError] = useState("");
    const [isAPILoading, setIsAPILoading] = useState(false);
    const [formData, setFormData] = useState({});

    const [zipCodes, setZipCodes] = useState([]);
    const [showZipDropdown, setShowZipDropdown] = useState(false);
    const [options, setOptions] = useState([]);
    const [picklistCache, setPicklistCache] = useState({});
    const [signature, setSignature] = useState(null);
    const [files, setFiles] = useState([{ id: 1, file: null, type: "" }]);
    const [showSignature, setShowSignature] = useState(false);
    const [signatureText, setSignatureText] = useState("");
    const [showFileUpload, setShowFileUpload] = useState(false);
    const [fileUploadText, setFileUploadText] = useState("");
    const [isSigned, setIsSigned] = useState(false);
    const [date, setDate] = useState("");
    const [error, setError] = useState(null);
    const sigPad = useRef(null);
    const [fileTypes, setFileTypes] = useState("");
    const [profileData, setProfileData] = useState(null);
    const [taxTypeOptions, setTaxTypeOptions] = useState([]);
    const [retailerOptions, setretailerOptions] = useState([]);

    const [exemptionCodeOptions, setExemptionCodeOptions] = useState([]);
    const [exemptionCodeFieldName, setExemptionCodeFieldName] = useState("");
    const [exemptionAmountFieldName, setExemptionAmountFieldName] = useState("");
    const [exemptionTaxTypeFieldName, setExemptionTaxTypeFieldName] = useState("");
    const [sectionGroups, setSectionGroups] = useState([{
        id: 1,
        exemptionGroups: [1],
        splitpayment: { fields: [], title: "Fuel Inventory Information", signature: null, signatureText: "", fileUpload: null, fileUploadText: "", fileTypes: "" },
        exemption: { fields: [], title: "Exemption Information", signature: null, signatureText: "", fileUpload: null, fileUploadText: "", fileTypes: "" }
    }]);
    const [taxPayerName, setTaxPayerName] = useState("");

    // State for tax calculations
    const [taxRates, setTaxRates] = useState({});
    const [splitPaymentFieldNames, setSplitPaymentFieldNames] = useState({
        'Gross Amount': '',
        'Reported Exempt Sales': '',
        'Payment for': '',
        'Actual Taxable Sales': '',
        'Actual Tax Amount Due': ''
    });

    useEffect(() => {
        const selectedTaxPayer = localStorage.getItem("selectedBusinessName");
        if (selectedTaxPayer) {
            setTaxPayerName(selectedTaxPayer);
        }
    }, []);

    // Simplified initial data effect
    useEffect(() => {
        if (Object.keys(initialData).length > 0) {
            setFormData(prevData => ({
                ...prevData,
                ...initialData
            }));
        }
    }, [initialData]);

    // Update tax rates when taxTypeOptions change
    useEffect(() => {
        if (taxTypeOptions.length > 0) {
            const rates = {};
            taxTypeOptions.forEach(option => {
                if (option.dval === "Sales Tax") rates[option.sval] = 0.02;
                if (option.dval === "Tobacco Products Tax") rates[option.sval] = 0.07;
                if (option.dval === "Liquor Privilege Tax") rates[option.sval] = 0.03;
                if (option.dval === "Restaurant Privilege") rates[option.sval] = 0.01;
                if (option.dval === "Sales Tax (Excess of $2500 on Single Item Sale)") rates[option.sval] = 0.02;
                if (option.dval === "Transient Lodging Tax") rates[option.sval] = 0.10;
                if (option.dval === "Utility Business Activity Tax") rates[option.sval] = 0.10;
                // Add more tax types as needed
            });
            setTaxRates(rates);
        }
    }, [taxTypeOptions]);

    // Initialize field names when sectionGroups are set
    useEffect(() => {
        if (sectionGroups.length > 0 && sectionGroups[0].splitpayment.fields.length > 0) {
            const splitFields = sectionGroups[0].splitpayment.fields;
            const fieldNameMap = {};

            [
                'Gross Amount',
                'Reported Exempt Sales',
                'Payment for',
                'Actual Taxable Sales',
                'Actual Tax Amount Due'
            ].forEach(displayName => {
                const field = splitFields.find(f => f.displayname === displayName);
                if (field) fieldNameMap[displayName] = field.fieldname;
            });

            setSplitPaymentFieldNames(fieldNameMap);
        }
    }, [sectionGroups]);

    // Debounced data change effect
    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            if (onDataChange && typeof onDataChange === 'function') {
                const formattedData = formatFuelInventoryData(formData, sectionGroups);
                console.log("vivek")
                console.log(formattedData)
                console.log("dogra")
                onDataChange(formattedData);
            }
        }, 300);

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [formData, sectionGroups]);

    const formatFuelInventoryData = useCallback((formData, sectionGroups) => {
        const formattedData = {
            fuelInventory: []
        };

        sectionGroups.forEach(group => {
            const inventoryGroup = {};

            // Process split payment fields
            if (group.splitpayment && group.splitpayment.fields) {
                group.splitpayment.fields.forEach(field => {
                    // Check if field.fieldname exists and is not empty
                    if (field.fieldname && field.fieldname.trim() !== '') {
                        const fieldKey = `${field.fieldname}_${group.id}`;
                        if (formData[fieldKey] !== undefined && formData[fieldKey] !== '') {
                            inventoryGroup[field.fieldname] = formData[fieldKey];
                        }
                    }
                });
            }

            formattedData.fuelInventory.push(inventoryGroup);
        });

        return formattedData;
    }, []);

    // Fixed tax calculation effect - only runs when not user-initiated
    useEffect(() => {
        if (isCalculatingRef.current) return;

        const calculateTaxes = () => {
            if (Object.values(splitPaymentFieldNames).every(name => name !== '')) {
                isCalculatingRef.current = true;

                const updates = {};
                let hasUpdates = false;

                sectionGroups.forEach(group => {
                    const taxTypeKey = `${splitPaymentFieldNames['Payment for']}_${group.id}`;
                    const grossAmountKey = `${splitPaymentFieldNames['Gross Amount']}_${group.id}`;
                    const exemptSalesKey = `${splitPaymentFieldNames['Reported Exempt Sales']}_${group.id}`;
                    const taxableSalesKey = `${splitPaymentFieldNames['Actual Taxable Sales']}_${group.id}`;
                    const taxDueKey = `${splitPaymentFieldNames['Actual Tax Amount Due']}_${group.id}`;

                    const taxType = formData[taxTypeKey];
                    const grossAmount = parseFloat(formData[grossAmountKey] || 0);
                    const exemptSales = parseFloat(formData[exemptSalesKey] || 0);

                    if (taxType && !isNaN(grossAmount) && grossAmount > 0) {
                        const taxRate = taxRates[taxType] || 0;
                        const taxableSales = Math.max(0, grossAmount - exemptSales);
                        const taxDue = taxableSales * taxRate;

                        const newTaxableSales = taxableSales.toFixed(2);
                        const newTaxDue = taxDue.toFixed(2);

                        if (formData[taxableSalesKey] !== newTaxableSales) {
                            updates[taxableSalesKey] = newTaxableSales;
                            hasUpdates = true;
                        }
                        if (formData[taxDueKey] !== newTaxDue) {
                            updates[taxDueKey] = newTaxDue;
                            hasUpdates = true;
                        }
                    }
                });

                if (hasUpdates) {
                    setFormData(prev => ({ ...prev, ...updates }));
                }

                setTimeout(() => {
                    isCalculatingRef.current = false;
                }, 100);
            }
        };

        const timeoutId = setTimeout(calculateTaxes, 500);
        return () => clearTimeout(timeoutId);
    }, [
        splitPaymentFieldNames,
        JSON.stringify(taxRates),
        // Only include the specific fields that should trigger calculation
        JSON.stringify(sectionGroups.map(group => ({
            taxType: formData[`${splitPaymentFieldNames['Payment for']}_${group.id}`],
            grossAmount: formData[`${splitPaymentFieldNames['Gross Amount']}_${group.id}`],
            exemptSales: formData[`${splitPaymentFieldNames['Reported Exempt Sales']}_${group.id}`]
        })))
    ]);

    useEffect(() => {
        const fetchFormFields = async (itype, stype) => {
            setIsLoading(true);
            try {
                const response = await fetch(UTILS, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "application/json"
                    },
                    body: new URLSearchParams({
                        action: "desc",
                        itype: itype,
                        stype: stype,
                    }),
                });

                const text = await response.text();
                const cleanedText = text.replace(/[\x00-\x1F\x7F-\x9F]/g, "");
                console.log(cleanedText);

                let data;
                try {
                    data = JSON.parse(cleanedText);

                } catch (parseError) {
                    console.error("Failed to parse form fields:", parseError);
                    throw new Error("Invalid server response format");
                }

                if (response.ok) {
                    return data;
                } else {
                    throw new Error(data.message || "Failed to fetch form fields");
                }
            } catch (error) {
                console.log(itype)
                console.log(stype)
                console.error("Error loading form:", error);
                setError(error.message);
                return null;
            }
        };

        const fetchDropDownFields = async (itemValueGroup) => {
            if (picklistCache[itemValueGroup]?.data) return;

            setPicklistCache((prev) => ({
                ...prev,
                [itemValueGroup]: { ...prev[itemValueGroup], isLoading: true },
            }));

            try {
                const response = await fetch(UTILS, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "application/json"
                    },
                    body: new URLSearchParams({ action: "idv", s: itemValueGroup || "YesNo" }),
                });

                const text = await response.text();
                const cleanedText = text.replace(/[\x00-\x1F\x7F-\x9F]/g, "");
                let data;
                try {
                    data = JSON.parse(cleanedText);
                } catch (parseError) {
                    console.error("Failed to parse dropdown data:", parseError);
                    console.error("Original text:", text);
                    throw new Error("Invalid dropdown data format");
                }

                setPicklistCache((prev) => ({
                    ...prev,
                    [itemValueGroup]: { data, isLoading: false },
                }));
            } catch (error) {
                console.error("Error fetching dropdown:", error);
                setPicklistCache((prev) => ({
                    ...prev,
                    [itemValueGroup]: { isLoading: false, error: error.message },
                }));
            }
        };

        const fetchAndCombineData = async () => {
            try {
                const splitPaymentData = await fetchFormFields("clin", "fuelinventory");

                if (!splitPaymentData) return;

                setSectionGroups([{
                    id: 1,
                    exemptionGroups: [1],
                    splitpayment: {
                        fields: splitPaymentData.Fields || [],
                        signature: splitPaymentData.Signature,
                        signatureText: splitPaymentData.SignatureText || "",
                        fileUpload: splitPaymentData.FileUpload,
                        fileUploadText: splitPaymentData.FileUploadText || "",
                        fileTypes: splitPaymentData.FileTypes || ""
                    },
                    exemption: {
                        fields: [], // Empty array since you don't have exemption data
                        signature: null,
                        signatureText: "",
                        fileUpload: null,
                        fileUploadText: "",
                        fileTypes: ""
                    }
                }]);

                const allFields = [
                    ...(splitPaymentData.Fields || [])
                ];

                // Initialize form data with proper field naming
                const initialFormData = {};
                allFields.forEach((field) => {
                    const fieldKey = `${field.fieldname}_1`; // Default to group 1
                    if (field.defaultvalue) {
                        initialFormData[fieldKey] = field.defaultvalue;
                    } else {
                        // Initialize with empty string to ensure controlled inputs
                        initialFormData[fieldKey] = "";
                    }
                });

                if (exemptionCodeFieldName) {
                    initialFormData[`${exemptionCodeFieldName}_1_1`] = "";
                }
                if (exemptionAmountFieldName) {
                    initialFormData[`${exemptionAmountFieldName}_1_1`] = "";
                }
                if (exemptionTaxTypeFieldName) {
                    initialFormData[`${exemptionTaxTypeFieldName}_1_1`] = "";
                }

                setFormData(initialFormData);

                const hasSignature = splitPaymentData.Signature;
                const hasFileUpload = splitPaymentData.FileUpload;

                setShowSignature(hasSignature);
                setShowFileUpload(hasFileUpload);

                const picklistFields = allFields.filter(
                    (field) => field.fieldtype === "picklist"
                );
                await Promise.all(
                    picklistFields.map(async (field) => {
                        await fetchDropDownFields(field.itemvaluegroup);
                    })
                );
            } catch (error) {
                console.error("Error in fetchAndCombineData:", error);
                setError(error.message);
            } finally {
                setIsLoading(false);
            }
        };

        fetchAndCombineData();
    }, [exemptionCodeFieldName, exemptionAmountFieldName, exemptionTaxTypeFieldName]);

    useEffect(() => {
        const fetchTaxTypes = async () => {
            try {
                const response = await fetch(UTILS, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "application/json"
                    },
                    body: new URLSearchParams({
                        action: "sqlo",
                        itype: "funding",
                        stype: "splitpayment",
                        fldn: "flexfield31"
                    }),
                });

                const text = await response.text();
                const cleanedText = text.replace(/[\x00-\x1F\x7F-\x9F]/g, "");
                console.log("tax types")
                console.log(cleanedText)
                console.log("tax types")
                let data;
                try {
                    data = JSON.parse(cleanedText);
                } catch (parseError) {
                    console.error("Failed to parse tax type data:", parseError);
                    throw new Error("Invalid tax type data format");
                }

                if (response.ok) {
                    setTaxTypeOptions(data);
                } else {
                    throw new Error(data.message || "Failed to fetch tax types");
                }
            } catch (error) {
                console.error("Error fetching tax types:", error);
            }
        };
        fetchTaxTypes();

    }, []);

    useEffect(() => {
        const fetchRetailerTypes = async () => {
            try {
                const response = await fetch(UTILS, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "application/json"
                    },
                    body: new URLSearchParams({
                        action: "sqlo",
                        itype: "clin",
                        stype: "packsdistributed",
                        fldn: "acrn"
                    }),
                });

                const text = await response.text();
                const cleanedText = text.replace(/[\x00-\x1F\x7F-\x9F]/g, "");
                console.log("retailer types")
                console.log(cleanedText)
                console.log("retailer types")
                let data;
                try {
                    data = JSON.parse(cleanedText);
                } catch (parseError) {
                    console.error("Failed to parse tax type data:", parseError);
                    throw new Error("Invalid tax type data format");
                }

                if (response.ok) {
                    setretailerOptions(data);
                } else {
                    throw new Error(data.message || "Failed to fetch tax types");
                }
            } catch (error) {
                console.error("Error fetching tax types:", error);
            }
        };
        fetchRetailerTypes();

    }, []);

    const handleAddSectionGroup = () => {
        const newGroupId = sectionGroups.length > 0
            ? Math.max(...sectionGroups.map(g => g.id)) + 1
            : 1;

        if (!sectionGroups[0] || !sectionGroups[0].splitpayment || !sectionGroups[0].exemption) {
            console.error("Cannot add section group: missing required data structure");
            return;
        }

        setSectionGroups(prev => [
            ...prev,
            {
                id: newGroupId,
                exemptionGroups: [1],
                splitpayment: { ...prev[0].splitpayment },
                exemption: { ...prev[0].exemption }
            }
        ]);

        const initialData = {};

        const splitFields = sectionGroups[0]?.splitpayment?.fields || [];
        const exemptionFields = sectionGroups[0]?.exemption?.fields || [];

        [...splitFields, ...exemptionFields].forEach(field => {
            const fieldKey = `${field.fieldname}_${newGroupId}`;
            if (field && field.defaultvalue) {
                initialData[fieldKey] = field.defaultvalue;
            } else {
                initialData[fieldKey] = "";
            }
        });

        setFormData(prev => ({
            ...prev,
            ...initialData,
            ...(exemptionCodeFieldName && { [`${exemptionCodeFieldName}_${newGroupId}_1`]: "" }),
            ...(exemptionAmountFieldName && { [`${exemptionAmountFieldName}_${newGroupId}_1`]: "" }),
            ...(exemptionTaxTypeFieldName && { [`${exemptionTaxTypeFieldName}_${newGroupId}_1`]: "" })
        }));
    };

    const handleRemoveSectionGroup = (groupId) => {
        if (sectionGroups.length > 1) {
            setSectionGroups(prev => prev.filter(group => group.id !== groupId));
            setFormData(prev => {
                const newData = { ...prev };
                Object.keys(prev).forEach(key => {
                    if (key.endsWith(`_${groupId}`) ||
                        key.startsWith(`${exemptionCodeFieldName}_${groupId}_`) ||
                        key.startsWith(`${exemptionAmountFieldName}_${groupId}_`) ||
                        key.startsWith(`${exemptionTaxTypeFieldName}_${groupId}_`)) {
                        delete newData[key];
                    }
                });
                return newData;
            });
        }
    };

    // Fixed handleChange function
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        // Prevent calculation interference during user input
        isCalculatingRef.current = false;

        setFormData((prevFormData) => {
            let newValue;

            if (type === 'checkbox') {
                const currentValues = prevFormData[name] || [];
                newValue = checked
                    ? [...currentValues, value]
                    : currentValues.filter(item => item !== value);
            } else {
                newValue = value;
            }

            return { ...prevFormData, [name]: newValue };
        });
    };

    const clearExemptionCodesForGroup = (groupId) => {
        setFormData(prev => {
            const newData = { ...prev };

            // Find all exemption code fields for this group and clear them
            Object.keys(prev).forEach(key => {
                if (key.startsWith(`${exemptionCodeFieldName}_${groupId}_`)) {
                    newData[key] = "";
                }

                // Optionally clear exemption amounts too
                if (key.startsWith(`${exemptionAmountFieldName}_${groupId}_`)) {
                    newData[key] = "";
                }
            });

            return newData;
        });

        // Also clear the exemption code options cache for this group
        setExemptionCodeOptions(prev => {
            const newOptions = { ...prev };
            Object.keys(newOptions).forEach(key => {
                if (key.startsWith(`${groupId}_`)) {
                    delete newOptions[key];
                }
            });
            return newOptions;
        });
    };

    const handleCheckboxGroupChange = (e, fieldName) => {
        const { value, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [fieldName]: checked
                ? [...(prev[fieldName] || []), value]
                : (prev[fieldName] || []).filter(item => item !== value)
        }));
    };

    if (isLoading) {
        return (
            <div className="flex flex-col items-center justify-center h-64 space-y-4">
                <div className="relative">
                    <div className="w-16 h-16 rounded-full absolute border-4 border-gray-200"></div>
                    <div className="w-16 h-16 rounded-full animate-spin border-4 border-primary border-t-transparent border-r-transparent"></div>

                    <div className="absolute inset-0 flex items-center justify-center">
                        <svg
                            className="w-6 h-6 text-primary"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 14l-7 7m0 0l-7-7m7 7V3"
                            ></path>
                        </svg>
                    </div>
                </div>

                <div className="flex flex-col items-center space-y-2">
                    <p className="text-gray-600 font-medium text-lg animate-pulse">Preparing Your Form...</p>
                    <div className="flex space-x-2">
                        {[...Array(3)].map((_, i) => (
                            <div
                                key={i}
                                className="w-2 h-2 bg-primary rounded-full animate-bounce"
                                style={{ animationDelay: `${i * 0.1}s` }}
                            ></div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="bg-white p-8 rounded-lg shadow-lg text-center">
                <h2 className="text-2xl font-bold text-red-600 mb-4">Error Loading Form</h2>
                <p className="text-gray-700 mb-4">{error}</p>
                <button
                    onClick={() => window.location.reload()}
                    className="bg-[#711515] text-white px-6 py-2 rounded-lg hover:bg-[#5a1010] transition"
                >
                    Try Again
                </button>
            </div>
        );
    }

    return (
        <div className="w-[95%] md:w-[80%] p-4 md:p-8 mx-auto bg-white mt-5 rounded-lg">
            {error && (
                <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-6 rounded">
                    <p>{error}</p>
                </div>
            )}

            {taxPayerName && (
                <p className="text-lg text-gray-600 -mt-6 text-center font-semibold">
                    For: <span className="text-lg  text-[#711515]">{taxPayerName}</span>
                </p>
            )}

            <div className="flex flex-col gap-8">
                {/* Section Groups (Split Payment + Exemption) */}
                {sectionGroups.map((group) => (
                    <div key={group.id} className="border border-gray-200 rounded-lg p-6">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-xl font-bold text-gray-800">Line {group.id}</h3>
                            {group.id > 1 && (
                                <button
                                    type="button"
                                    onClick={() => handleRemoveSectionGroup(group.id)}
                                    className="text-red-500 hover:text-red-700 font-medium"
                                >
                                    Remove Line
                                </button>
                            )}
                        </div>

                        {/* Split Payment Information */}
                        <div className="mb-8">
                            <h4 className="text-lg font-bold text-gray-700 border-b border-gray-300 pb-2 mb-4">
                                {group.splitpayment.title}
                            </h4>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {group.splitpayment.fields
                                    .filter(
                                        (field) =>
                                            ![
                                                "itemid",
                                                "autonumber",
                                                "readonlydate",
                                                "readonlypicklist",
                                                "readonly",
                                                "hidden",
                                                "readonlylookup",
                                                "linkedfield",
                                                "inlinequery",
                                                "person",
                                            ].includes(field.fieldtype)
                                    )
                                    .sort((a, b) => a.sortorder - b.sortorder)
                                    .map((field) => (
                                        <div className={`${field.fieldtype === "label" ? "col-span-2" : "col-span-1"}`} key={`split_${group.id}_${field.displayid}`}>
                                            <label className={`block ${field.fieldtype === "label" ? "font-bold text-base text-xl w-full" : "text-gray-700 font-semibold"} mb-3`}>
                                                {field.required === "Y" && <span className="text-[#711515]">*</span>} {field.displayname}
                                                {field.tooltip && (
                                                    <div className="inline-block relative ml-2 group">
                                                        <svg
                                                            className="w-5 h-5 text-gray-400 cursor-help"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            viewBox="0 0 24 24"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth="2"
                                                                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                                            />
                                                        </svg>
                                                        <div className="absolute left-1/2 transform -translate-x-1/2 bottom-full mb-2 w-64 p-2 bg-gray-800 text-white text-sm rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-10">
                                                            {field.tooltip}
                                                            <div className="absolute left-1/2 transform -translate-x-1/2 top-full w-2 h-2 bg-gray-800 rotate-45"></div>
                                                        </div>
                                                    </div>
                                                )}
                                            </label>

                                            {field.displayname === "Retailer" ? (
                                                <div className="relative">
                                                    <select
                                                        name={`${field.fieldname}_${group.id}`}
                                                        value={formData[`${field.fieldname}_${group.id}`] || ""}
                                                        onChange={handleChange}
                                                        className="w-full p-4 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent appearance-none"
                                                        required={field.required === "Y"}
                                                    >
                                                        <option value="">Select Retailer</option>
                                                        {retailerOptions.map((option, index) => (
                                                            <option key={index} value={option.sval}>
                                                                {option.dval}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-700">
                                                        <svg
                                                            className="h-4 w-4"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 20 20"
                                                            fill="currentColor"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                                clipRule="evenodd"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            ) : field.fieldtype === "date" ? (
                                                <input
                                                    type="date"
                                                    name={`${field.fieldname}_${group.id}`}
                                                    value={formData[`${field.fieldname}_${group.id}`] || ""}
                                                    onChange={handleChange}
                                                    className="w-full p-4 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent"
                                                    required={field.required === "Y"}
                                                />
                                            ) : field.fieldtype === "text" || field.fieldtype === "numeric" || field.fieldtype === "currency" || field.fieldtype === "textdate" ? (
                                                <input
                                                    type="text"
                                                    name={`${field.fieldname}_${group.id}`}
                                                    value={formData[`${field.fieldname}_${group.id}`] || ""}
                                                    onChange={handleChange}
                                                    className="w-full p-4 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent"
                                                    required={field.required === "Y"}
                                                    maxLength={field.maxlength || ""}
                                                />
                                            ) : field.fieldtype === "textarea" ? (
                                                <textarea
                                                    name={`${field.fieldname}_${group.id}`}
                                                    value={formData[`${field.fieldname}_${group.id}`] || ""}
                                                    onChange={handleChange}
                                                    className="w-full p-4 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent"
                                                    required={field.required === "Y"}
                                                    rows="4"
                                                ></textarea>
                                            ) : field.fieldtype === "picklist" ? (
                                                <div className="relative">
                                                    <select
                                                        name={`${field.fieldname}_${group.id}`}
                                                        value={formData[`${field.fieldname}_${group.id}`] || ""}
                                                        onChange={handleChange}
                                                        className="w-full p-4 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent appearance-none"
                                                        required={field.required === "Y"}
                                                    >
                                                        <option value="">Select {field.displayname}</option>
                                                        {picklistCache[field.itemvaluegroup]?.data?.map((option) => (
                                                            <option key={option.valueid} value={option.valuetext}>
                                                                {option.valuetext}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-700">
                                                        <svg
                                                            className="h-4 w-4"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 20 20"
                                                            fill="currentColor"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                                clipRule="evenodd"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            ) : field.fieldtype === "checkbox" ? (
                                                <CheckboxField
                                                    field={field}
                                                    formData={formData}
                                                    handleCheckboxGroupChange={handleCheckboxGroupChange}
                                                    picklistCache={picklistCache}
                                                    setPicklistCache={setPicklistCache}
                                                    groupId={group.id}
                                                />
                                            ) : field.fieldtype === "radio" ? (
                                                <RadioField
                                                    field={field}
                                                    formData={formData}
                                                    handleChange={handleChange}
                                                    picklistCache={picklistCache}
                                                    setPicklistCache={setPicklistCache}
                                                    groupId={group.id}
                                                />
                                            ) : null}
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                ))}

                {/* Add Section Group Button */}
                <button
                    type="button"
                    onClick={handleAddSectionGroup}
                    className="flex items-center justify-center bg-[#711515] text-white px-6 py-3 rounded-lg hover:bg-[#5a1010] transition"
                >
                    <svg
                        className="w-5 h-5 mr-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                    Add Another Line
                </button>
            </div>
        </div>
    );
};

export default FuelInventory;